export const REGION_COOKIE_NAME = 'region'
export const CART_ID_COOKIE_NAME = 'cartId'
